/**
 * OrbDocIndexENOrbDocIndexENPage
 *
 * Page component for OrbDocIndexENOrbDocIndexENPage
 * Path: /docs
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocIndexENDocScreenView as __OrbDocIndexENDocScreenView } from '@/components/traits/OrbDocIndexENDocScreenView';
import { OrbDocIndexENDocAnalyticsView as __OrbDocIndexENDocAnalyticsView } from '@/components/traits/OrbDocIndexENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocIndexENOrbDocIndexENPageProps {
  // Add any page-level props here
}

export function OrbDocIndexENOrbDocIndexENPage(_props: OrbDocIndexENOrbDocIndexENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Orb documentation","description":"Learn the language, compose the standard library, and look up every operator and behavior.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs"},{"locale":"ar","path":"/ar/docs"},{"locale":"sl","path":"/sl/docs"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocIndexENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocIndexENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocIndexENOrbDocIndexENPage;
